import { render } from "./MachineLearning.vue?vue&type=template&id=84a4fc9c&scoped=true"
import script from "./MachineLearning.vue?vue&type=script&lang=js"
export * from "./MachineLearning.vue?vue&type=script&lang=js"

import "./MachineLearning.vue?vue&type=style&index=0&id=84a4fc9c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a4fc9c"]])

export default __exports__